<template>
    <div class="booking-service-item">
        <div class="row">
            <div class="col-auto image-container">
                <avatar-badge :src="displayImage" class="mt-5" update-event="display-image-updated" :raised="false" :size="100"></avatar-badge>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col"><h2 class="service-name" v-text="shopService.name"></h2></div>
                    <div class="col-auto">
                        PHP <span class="price text-right" v-text="bookingItem.price_per_unit"></span>
                    </div>
                </div>
                <div class="description" v-text="subcategory.name"></div>
                <div class="description">
                    Quantity: <span class="font-weight-700" v-text="bookingItem.quantity"></span>
                </div>
                <div class="description">
                    Experts:
                    <span v-if="bookingItem.experts.length > 0" class="font-weight-700" v-text="expertNames"></span>
                    <span v-else class="font-weight-700 text-muted">No experts assigned</span>
                </div>
                <div v-if="bookingItem.discount_code_amount" class="description">
                    Voucher Discount:
                    <span v-if="bookingItem.discount_code_type == 'percentage'" class="font-weight-700">
                        PHP {{ voucherDiscountAmount.toFixed(2) }} ({{ voucherDiscount.toFixed(2) }}%)
                    </span>
                    <span v-else class="font-weight-700">
                        PHP {{ voucherDiscountAmount.toFixed(2) }}
                    </span>
                </div>
                <div v-if="additionalDiscounts" class="description">
                    Additional Discount: <span class="font-weight-700">PHP {{ additionalDiscounts.toFixed(2) }}</span>
                </div>
                <div class="text-right">
                    <button class="btn btn-warning btn-sm" @click="edit">
                        <i class="fa fa-edit mr-2"></i> Edit
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "BookingItemPane",

    computed: {
        displayImage() {
            return this.bookingItem.shopService.display_image;
        },
        subcategory() {
            return this.bookingItem.subcategory
        },
        shopService() {
            return this.bookingItem.shopService;
        },
        expertNames() {
            return this.bookingItem.experts.map(expert => expert.fullname).join(', ');
        },
        pricePerUnit() {
            return parseFloat(this.bookingItem.price_per_unit || 0);
        },
        voucherDiscountAmount() {
            const discount = this.bookingItem.discount_code_type == "percentage"
                ? (this.pricePerUnit * parseFloat(this.bookingItem.quantity)) * (this.bookingItem.discount_code_amount * 0.01)
                : this.bookingItem.discount_code_amount;
            return parseFloat(discount);
        },
        voucherDiscount() {
            return parseFloat(this.bookingItem.discount_code_amount || 0);
        },
        additionalDiscounts() {
            return parseFloat(this.bookingItem.additional_discounts || 0);
        },
    },

    methods: {
        edit() {
            this.$emit("edit", this.bookingItem);
        }
    },
    

    props: {
        bookingItem: Object,
    }
}
</script>